import React from "react";
import { X } from "lucide-react";

export type TagVariant = "neutral" | "success" | "danger";
export type TagSize = "sm" | "md";

interface TagProps {
  label: string;
  variant?: TagVariant;
  size?: TagSize;
  onRemove?: () => void;
}

const VARIANT_STYLES: Record<TagVariant, string> = {
  neutral: "bg-cream-200 dark:bg-cream-700",
  success:
    "bg-success-100 text-success-700 dark:bg-success-700 dark:text-success-100",
  danger:
    "bg-danger-100 text-danger-700 dark:bg-danger-700 dark:text-danger-100",
};

const SIZE_STYLES: Record<TagSize, string> = {
  sm: "text-sm",
  md: "",
};

const Tag: React.FC<TagProps> = ({
  label,
  variant = "neutral",
  size = "md",
  onRemove,
}) => {
  return (
    <div
      className={`flex items-center gap-2 rounded-full px-3 py-1 font-medium ${SIZE_STYLES[size]} ${VARIANT_STYLES[variant]}`.trim()}
    >
      <span className="whitespace-nowrap">{label}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="text-cream-600 hover:text-cream-900 dark:text-cream-400 dark:hover:text-cream-100 transition-colors"
          aria-label={`Remove ${label}`}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
};

export default Tag;
